import { centerable as t } from "../decorators/centerable.js";
import { stylable as r } from "../decorators/stylable.js";
import { BLOCK_CLASSES as o } from "../../constants.js";
import { defineAttrs as e } from "../../utils/typed-attrs.js";
const i = e({
  type: { default: "social" },
  items: { default: void 0 }
}), m = r(
  t({
    content: "",
    group: "block",
    attrs: i,
    toDOM(c) {
      return [
        "div",
        {
          class: `${o.blockContainer} ${o.social} intercom-social-container`
        }
      ];
    }
  })
);
export {
  m as socialSpec
};
